/**
 * SEPARA EL ARRAY EN BLOQUES DEFINIDOS
 * @param {Int32Array} arr 
 * @param {Number} size 
 * @returns ARRAY DE HISTORIAL SEPARADOS POR SIZE
 */
function agruparArray(arr, size) {
    var myArray = [];
    for (var i = 0; i < arr.length; i += size) {
        myArray.push(arr.slice(i, i + size));
    }
    return myArray;
}

export default agruparArray;